module.exports = __webpack_public_path__ + "ajax-loader.gif";


//////////////////
// WEBPACK FOOTER
// ./~/slick-carousel/slick/ajax-loader.gif
// module id = 159
// module chunks = 0